import request from "@/util/http";
/**
 * 列表
 */
export function list(query) {
	return request({
		url: '/upms/shop/address/list',
		method: 'get',
		params: query,
	})
}

/**
 * 添加
 */
export function add(query) {
	return request({
		url: '/upms/shop/address/add',
		method: 'get',
		params: query,
	})
}

/**
 * 加载下级地区
 */
export function loadRegionChildren(query) {
	return request({
		url: '/upms/shop/address/load_region_children',
		method: 'get',
		params: query,
	})
}

/**
 * 查找地区
 */
export function loadRegion(query) {
	return request({
		url: '/upms/shop/address/load_region',
		method: 'get',
		params: query,
	})
}

/**
 * 保存
 */
export function save(data) {
	return request({
		url: '/upms/shop/address/save',
		method: 'post',
		data: data,
	})
}


/**
 * 编辑
 */
export function edit(query) {
	return request({
		url: '/upms/shop/address/edit',
		method: 'get',
		params: query,
	})
}

/**
 * 更新
 */
export function update(data) {
	return request({
		url: '/upms/shop/address/update',
		method: 'post',
		data: data,
	})
}

/**
 * 删除
 */
export function del(params) {
	return request({
		url: '/upms/shop/address/delete',
		method: 'delete',
		params: params,
	})
}

// module.exports = {
// 	list,
// 	add,
// 	save,
// 	edit,
// 	update,
// 	del,
// }
